import { render, staticRenderFns } from "./ClientPackage.vue?vue&type=template&id=3fff0fa1"
import script from "./ClientPackage.vue?vue&type=script&lang=js"
export * from "./ClientPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports